import { APEXEstimateData, APEXTableData } from "../commercials/data";
import { getApexStorage, getCountryStorage, getModel, getModelName, isAU} from "../common";
import { format, parse } from 'date-fns';
import { SpendData } from "../review/data";
import { shortFormNumber } from "../../utilities/customFunctions";



export const getCommercialData = (isMargin = false) => {
    let modelName = getModelName()    
    const country = getCountryStorage();
    
    let m = modelName;
    if(isMargin && isAU()) m = "unified-margin"
    //console.log(m, country)
    
    return APEXTableData.filter(function (el) {
        return el.commercialModel.toLowerCase().split(" ").join("") === m && el.country === country
    });
}

export const getSpendData = (model, country) => {
    
    var newArray = SpendData.filter(function (el) {
        return el.model.toLowerCase() === model && el.country === country
      });
      return newArray
}
export const getIndepData = () => {
    var newArray = APEXTableData.filter(function (el) {
        return el.commercialModel.toLowerCase() === "independent"
      });
      return newArray
}

export const getUniData = (isMargin = false) => {
    let label = getApexStorage()?.toLowerCase();
    var newArray = []
    if (isMargin){
        newArray = APEXTableData.filter(function (el) {
            return el.commercialModel.toLowerCase().split(" ").join("") === "unified-margin"
          });
    }
    else{
        newArray = APEXTableData.filter(function (el) {
            return el.commercialModel.toLowerCase().split(" ").join("") === label
          });
    }
   
      return newArray
}


export const formatBillingMonth = (billingMonthStr) => {
    const dateObj = parse(billingMonthStr, 'yyyy-MM', new Date());
    return format(dateObj, 'MMMM yyyy');
}

export const formatBillingDate = (billingMonthStr) => {
    const dateObj = parse(billingMonthStr, 'yyyy-MM-dd', new Date());
    return format(dateObj, 'dd-MMMM-yyyy');
}

let modal = getModel();

const constructDataEstimate = () => {
    // let apexType = getApexStorage()
    let data = APEXEstimateData

    const categories = [
        {
            category: data.map(item => ({
                label: item["billing_month"].charAt(0).toUpperCase() + item["billing_month"].slice(1)
            }))
        }
    ];

    // Construct dataset for Net Earnings and SaaS Fees
    const dataset = [
        {
            seriesname: "Est. Rewards",
            data: data.map(item => ({
                
                value: item.apex_earnings.replaceAll(",", "").replaceAll("$","")
            }))
        }
    ];
    return { categories: [...categories], dataset: [...dataset] }



}

const constructDataPie = () => {
    let isIndep = getApexStorage() === "independent" ? true : false;
    if (isIndep){
        return {"data":[
        {
            "label": "Operational costs",
            "value": "30"
        },
        {
            "label": "Vendor fees",
            "value": "30"
        },
        {
            "label": "AWS server costs",
            "value": "20"
        },
        {
            "label": "Product R&D",
            "value": "10"
        },
        {
            "label": "Technology Maintenance",
            "value": "10"
        }
    ]}
    }
    else{
        return {"data":[
            {
                "label": "Publisher media costs",
                "value": "60"
            },
            {
                "label": "Vendor fees",
                "value": "10"
            },
            {
                "label": "Operational costs",
                "value": "10"
            },
            {
                "label": "AWS server costs",
                "value": "10"
            },
            {
                "label": "Product R&D",
                "value": "5"
            },
            {
                "label": "Technology Maintenance",
                "value": "5"
            }
        ]}
    }

}


export const createDataSetEarnings = () => {
  const data = getCommercialData();
  const categories = data.map(item => item["billing month"]);

  const series = [
    {
      name: "Total Spend",
      type: "bar",
      stack: "earningsStack",
      data: data.map(item => Number(String(item.totalSpend).replaceAll(",", "")) || 0)
    },
    {
      name: "My Rewards",
      type: "bar",
      stack: "earningsStack",
      data: data.map(item => Number(String(item.totalFee).replaceAll(",", "")) || 0)
    }
  ];

  return {
    backgroundColor: "#fff",
    color: ["#1272a4", "#8cca8b", "#e06e5e", "#fec663", "#01baef", "#BC95DF", "#67CDF2"],
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      formatter: params => {
        if (!params) return "";
        const items = Array.isArray(params) ? params : [params];
        let tooltip = `${items[0].axisValue}<br/>`;
        items.forEach(p => {
          tooltip += `${p.marker} <b>$${shortFormNumber(p.value)}</b> ${p.seriesName}<br/>`;
        });
        return tooltip;
      }
    },
    legend: { top: "bottom", left: "center" },
    grid: { left: "3%", right: "4%", bottom: "10%", top: "10%", containLabel: true },
    xAxis: {
      type: "category",
      data: categories,
      axisTick: { alignWithLabel: true }
    },
    yAxis: {
      type: "value",
      axisLabel: {
        formatter: (val) => "$" + shortFormNumber(val)
      }
    },
    // scrolling like Fusion numVisiblePlot = 18
    dataZoom: data.length > 18 ? [
      { type: "slider", show: true, xAxisIndex: 0, height: 12, bottom: 0 },
      { type: "inside", xAxisIndex: 0 }
    ] : [],
    series
  };
};


const constructDataFees = () => {
  let data = getCommercialData();

  const categories = data.map(item => item["billing month"]);

  const dataset = [
    {
      name: "Spend Through Platform",
      data: data.map(item => Number(item.totalSpend.replaceAll(",", "")))
    },
    {
      name: "SaaS Fees",
      data: data.map(item => Number(item.totalFee.replaceAll(",", "")))
    }
  ];

  return { categories, dataset };
};

export const createDataSetFees = () => {
  const data = getCommercialData();

  const categories = data.map(item => item["billing month"]);
  const dataset = [
    {
      name: "Spend Through Platform",
      data: data.map(item => Number(item.totalSpend.replaceAll(",", "")))
    },
    {
      name: "SaaS Fees",
      data: data.map(item => Number(item.totalFee.replaceAll(",", "")))
    }
  ];

  const paletteColors = [
    "#1272a4",
    "#e06e5e",
    "#8cca8b",
    "#fec663",
    "#01baef",
    "#BC95DF",
    "#67CDF2"
  ];

  return {
    backgroundColor: "#fff", // white background
    color: paletteColors,
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      formatter: params => {
        let t = `${params[0].axisValue}<br/>`;
        params.forEach(p => {
          t += `${p.marker} ${p.seriesName}: <b>$${shortFormNumber(p.value)}</b><br/>`;
        });
        return t;
      }
    },
    legend: { top: "bottom", left: "center" },
    grid: { left: "3%", right: "4%", bottom: "10%", top: "10%", containLabel: true },
    xAxis: {
      type: "category",
      data: categories
    },
    yAxis: {
      type: "value",
      axisLabel: {
        formatter: value => `$${shortFormNumber(value)}`
      }
    },
    series: dataset.map(s => ({
      name: s.name,
      type: "bar",
      stack: "total",
      barMaxWidth: 40,
      data: s.data
    }))
  };
};


export const createDataReview = (model, country) => {
  let data = getSpendData(model, country);
  const categories = data.map(item => item["month"]);

  const series = [
    {
      name: "Monthly Commitment",
      type: "bar",
      barGap: "0%",
      barCategoryGap: "20px",
      data: data.map(item => Number(String(item.predicted_spend_commitment).replaceAll(",", "")) || 0)
    },
    {
      name: "Platform Spend",
      type: "bar",
      barGap: "0%",
      barCategoryGap: "20px",
      data: data.map(item => Number(String(item.actual_spend).replaceAll(",", "")) || 0)
    },
    {
      name: "Gap to Commitment",
      type: "bar",
      barGap: "0%",
      barCategoryGap: "20px",
      data: data.map(item => Number(String(item.gap_to_commitment).replaceAll(",", "")) || 0)
    }
  ];

  return {
    backgroundColor: "#fff",
    color: ["#1272a4", "#8cca8b", "#e06e5e", "#fec663", "#01baef", "#BC95DF", "#67CDF2"],
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      formatter: params => {
        if (!params) return "";
        const items = Array.isArray(params) ? params : [params];
        let tooltip = `${items[0].axisValue}<br/>`;
        items.forEach(p => {
          tooltip += `${p.marker} <b>$${shortFormNumber(p.value)}</b> in ${p.seriesName}<br/>`;
        });
        return tooltip;
      }
    },
    legend: { top: "bottom", left: "center" },
    grid: { left: "3%", right: "4%", bottom: "10%", top: "10%", containLabel: true },
    xAxis: {
      type: "category",
      data: categories,
      axisTick: { alignWithLabel: true }
    },
    yAxis: {
      type: "value",
      axisLabel: {
        formatter: val => "$" + shortFormNumber(val)
      }
    },
    dataZoom: data.length > 18 ? [
      { type: "slider", show: true, xAxisIndex: 0, height: 12, bottom: 0 },
      { type: "inside", xAxisIndex: 0 }
    ] : [],
    series
  };
};



export const createDataSetSavings = (isMargin = false, isSpend = false) => {
  let data = getCommercialData(isMargin);
  const categories = data.map(item => item["billing month"]);

  // build series depending on spend or not
  let series = [];
  if (isSpend) {
    series = [
      {
        name: "Total Spend",
        type: "bar",
        barGap: "0%",
        barCategoryGap: "20px",
        data: data.map(item => Number(String(item.totalSpend).replaceAll(",", "")) || 0)
      },
      {
        name: "Spend Efficiencies (Discounts)",
        type: "bar",
        barGap: "0%",
        barCategoryGap: "20px",
        data: data.map(item => Number(String(item.totalFee).replaceAll(",", "")) || 0)
      }
    ];
  } else {
    series = [
      {
        name: isMargin ? "Margin" : "Impressions Gained",
        type: "bar",
        data: data.map(item =>
          isMargin
            ? Number(String(item.totalFee).replaceAll(",", "")) || 0
            : Number(String(item.impIncreased).replaceAll(",", "")) || 0
        )
      }
    ];
  }

  return {
    backgroundColor: "#fff", // white background
    color: ["#1272a4", "#8cca8b", "#e06e5e", "#fec663", "#01baef", "#BC95DF", "#67CDF2"],
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      formatter: params => {
        if (!params) return "";
        const items = Array.isArray(params) ? params : [params];
        let tooltip = `${items[0].axisValue}<br/>`;
        items.forEach(p => {
          tooltip += `${p.marker} <b>${isMargin ? "$" : ""}${shortFormNumber(p.value)}</b> in ${p.seriesName}<br/>`;
        });
        return tooltip;
      }
    },
    legend: { top: "bottom", left: "center" },
    grid: { left: "3%", right: "4%", bottom: "10%", top: "10%", containLabel: true },
    xAxis: {
      type: "category",
      data: categories,
      axisTick: { alignWithLabel: true }
    },
    yAxis: {
      type: "value",
      axisLabel: {
        formatter: (val) => isMargin ? "$" + shortFormNumber(val) : shortFormNumber(val)
      }
    },
    dataZoom: !isSpend && data.length > 18 ? [
      { type: "slider", show: true, xAxisIndex: 0, height: 12, bottom: 0 },
      { type: "inside", xAxisIndex: 0 }
    ] : [],
    series
  };
};





export const createDataSetEstimate = () => {
    return {
        chart: {
            // caption: "Deaths reported because of insect bites in India",
            // yaxisname: "Number of deaths reported",
            // subcaption: "(As per government records)",
            flatscrollbars: "1",
            scrollheight: "12",
            numberprefix: "$",
            numvisibleplot: "18",
            plottooltext:
                "<b>$dataValue</b> $seriesName in $label",
            theme: "buddy-theme"
        },
        ...constructDataEstimate()
    };
}

export const createDataSetPie = () => {
    return {
        "chart": {
            "caption": "BigAds fees breakdown",
            "bgColor": "#ffffff",
            "startingAngle": "180",
            "showLegend": "1",
            "defaultCenterLabel": "Fees breakdown",
            "centerLabel": "$label: $value",
            "centerLabelBold": "1",
            "showTooltip": "0",
            "decimals": "0",
            "theme": "fusion"
        },
        ...constructDataPie()
    };
}